import { useEffect, useMemo, useState } from 'react';
import { useMagic, useSmartWallet } from '@package/smart-wallet/providers';
import { useAccount } from 'wagmi';

export const useGetAccountInfo = () => {
  const [userEmail, setUserEmail] = useState<string | null>(null);
  const [eoaAddress, setEoaAddress] = useState<string | null>(null);
  const [isMagicLoading, setIsMagicLoading] = useState<boolean>(false);
  const { chain } = useAccount();
  const { magic } = useMagic();
  const { smartAccountAddress, isLoading: isLoadingSafeWallet } =
    useSmartWallet();

  /* Effects */
  useEffect(() => {
    const getAccountInfo = async () => {
      setIsMagicLoading(true);
      const user = await magic?.user.getInfo();
      if (user) {
        setUserEmail(user?.email);
        setEoaAddress(user?.publicAddress);
      }
      setIsMagicLoading(false);
    };

    getAccountInfo();
  }, [magic]);

  /* Memos */
  const chainId = useMemo(() => {
    return chain?.id;
  }, [chain]);

  const isLoading = useMemo(() => {
    return isLoadingSafeWallet || isMagicLoading;
  }, [isLoadingSafeWallet, isMagicLoading]);

  /* Return */
  return {
    isLoading,
    chainId,
    userEmail,
    eoaAddress,
    smartAccountAddress,
  };
};
